import { Route, BrowserRouter as Router, Routes } from 'react-router'
import './App.css'
import AppLayout from './layout/AppLayout'
import AuthLayout from './layout/AuthLayout'
import SignIn from './pages/AuthPages/SignIn'
import SignUp from './pages/AuthPages/SignUp'
import Business from './pages/Business/Business'
import Company from './pages/Company/Company'
import CompanyDetail from './pages/Company/Detail/CompanyDetail'
import DashboardPage from './pages/Dashboard/DashboardPage'
import NotFound from './pages/OtherPage/NotFound'
import ProductDetail from './pages/Product/Detail/ProductDetail'
import Product from './pages/Product/Product'
import ProfessionalDetailPage from './pages/Professional/Detail/ProfessionalDetailPage'
import ProfessionalPage from './pages/Professional/ProfessionalPage'

function App() {
    return (
        <Router>
            <Routes>
                {/* Dashboard Layout */}
                <Route element={<AppLayout />}>
                    <Route index path='/' element={<DashboardPage />} />

                    {/* Negócios */}
                    <Route index path='/negocio' element={<Business />} />
                    <Route index path='/negocio/:id' element={<Business />} />

                    {/* Empresa */}
                    <Route index path='/empresa' element={<Company />} />
                    <Route index path='/empresa/:id' element={<CompanyDetail />} />

                    {/* Profissional */}
                    <Route index path='/profissional' element={<ProfessionalPage />} />
                    <Route index path='/profissional/:id' element={<ProfessionalDetailPage />} />

                    {/* Produto */}
                    <Route index path='/produto' element={<Product />} />
                    <Route index path='/produto/:id' element={<ProductDetail />} />
                </Route>

                {/* Auth Layout */}
                <Route element={<AuthLayout />}>
                    <Route path='/login' element={<SignIn />} />
                    <Route path='/signup' element={<SignUp />} />
                </Route>

                {/* Fallback Route */}
                <Route path='*' element={<NotFound />} />
            </Routes>
        </Router>
    )
}

export default App
